export const hasSkillFunctionality = (functionalities) => {
	return functionalities.some((func) => {
		if (func.functionality.customCode === 'SKILLS') {
			return true;
		}
	});
};
